<template>
  <div style="padding:10px;overflow:auto;height:80vh">
    <el-form :model="form" label-width="80px">
      <el-form-item label="产品名称">{{form.name}}</el-form-item>
      <el-form-item label="产品图片">
        <img :src="form.image" width="100" height="100" />
      </el-form-item>
      <el-form-item label="目录">
        <el-tree
          :data="form.catalogtree"
          node-key="id"
          default-expand-all
          :expand-on-click-node="false"
          :render-content="renderContent"
        ></el-tree>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
let tid = 1;
import config from "../../../api/config";
import { getProduct } from "../../../api/gm/api-product";
export default {
  data() {
    return {
      staticURL: config.staticURL, //图片域名
      datatype: [
        { value: 1, name: "无", canadd: true },
        { value: 2, name: "列表", canadd: false },
        { value: 3, name: "单页", canadd: false },
        { value: 4, name: "三维图", canadd: true },
        { value: 5, name: "选项卡", canadd: false }
      ],
      form: {
        //表单项
        id: 0,
        name: "",
        image: "",
        catalogtree: [
          {
            id: 0,
            label: "目录",
            type: 0,
            children: []
          }
        ]
      }
    };
  },
  components: {},
  created() {
    getProduct(this.$route.params.id).then(res => {
      if (res.code === 0) {
        this.form.id = res.data.id;
        this.form.name = res.data.name;
        this.form.image = this.staticURL + res.data.image;
        this.form.catalogtree = res.data.catalogTree;
      } else {
        this.$message.error(res.msg);
      }
    });
  },
  methods: {
    //..获取类型对应的中文名
    gettypename(type) {
      var name = "内容类型";
      this.datatype.filter(item => {
        if (item.value == type) {
          name = item.name;
          return;
        }
      });
      return name;
    },
    //..初始化内容
    renderContent(h, { node, data, store }) {
      if (tid < data.id) {
        tid = data.id;
      }

      if (node.id == 1) {
        return (
          <span class="custom-tree-node" width="100%">
            <span>{node.label}</span>
            <span class="mulutype">
              {"[" + this.gettypename(node.data.type) + "]"}
            </span>
          </span>
        );
      } else {
        //编辑,添加,删除
        return (
          <span class="custom-tree-node">
            <span>{node.data.label}</span>
            <span class="mulutype">
              {"[" + this.gettypename(node.data.type) + "]"}
            </span>
          </span>
        );
      }
    }
  }
};
</script>

<style scoped>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.mulutype {
  margin: 0 20px;
  color: #8c939d;
}
</style>


// WEBPACK FOOTER //
// src/pages/gm/product/view.vue